import React from 'react';

import Button from '@splunk/react-ui/Button';
import P from '@splunk/react-ui/Paragraph';

import { Modal } from '../Modal';
import {
    type ProtectedUrlModalProps,
    TEXT,
    StyledUrl,
    redirectionStyle,
    StyledNote,
} from './constants';

type InvalidModalProps = Omit<
    ProtectedUrlModalProps,
    'event' | 'addUrlToAllowList'
> & { url?: string };

export const InvalidUrlModal = ({
    url,
    onRequestClose,
    ...rest
}: InvalidModalProps) => {
    return (
        <Modal
            onRequestClose={onRequestClose}
            open={!!url}
            divider="none"
            {...rest}
        >
            <Modal.Header title={TEXT.INVALID_TITLE} />
            <Modal.Body>
                <StyledUrl>
                    <P style={redirectionStyle}>{TEXT.INVALID_REDIRECTION}</P>
                    <P>{url}</P>
                    <StyledNote>{TEXT.INVALID_NOTE}</StyledNote>
                </StyledUrl>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    appearance="primary"
                    onClick={onRequestClose}
                    label={TEXT.CLOSE}
                />
            </Modal.Footer>
        </Modal>
    );
};
